<template>
    <dash
        icon="fa fa-file-text-o"
        titulo="CONTRATOS GESCON"
        subTitulo="GESTOR"
        @click.native="$router.push({ name: 'Gescon_Gestores_Contratos' })"
        :qtd="qtd"
        :mostrarQtd="false"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
